import { Component, Input, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { BoardService } from 'src/shared/services/board.service';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { DragulaService } from 'ng2-dragula';
import { Observable, Subscription } from 'rxjs';
import { C, T } from '@angular/cdk/keycodes';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { first, take } from 'rxjs/operators';
import { element } from 'protractor';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmComponent } from 'src/app/+home/shared/components/dialog-confirm/dialog-confirm.component';
import { createNoSubstitutionTemplateLiteral, isIndexSignatureDeclaration } from 'typescript';
import { UserService } from 'src/shared/services/user/user.service';
import { DilogSeeDocumentComponent } from 'src/app/+home/+document-request/dilog-see-document/dilog-see-document.component';
import { UploadFilesService } from '../../../../../shared/services/uploadFileService.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { ZipOperator } from 'rxjs/internal/observable/zip';
import { rxSubscriber } from 'rxjs/internal-compatibility';


@Component({
  selector: 'app-board',
  templateUrl: './board.component.html',
  styleUrls: ['./board.component.scss'],
})



export class BoardComponent implements OnInit {
  @Input() column
  public item;
  public columns = [];
  public taskList = [];
  public isEdit = false;
  arrow: any;
  kanbanTitle = "";
  public kanbans = [];
  public add;
  public mySet;
  myGroup: FormGroup;
  columnLengths: any;
  kanban: any;
  user: string;
  filterOn: boolean;
  personToSee: any;
  cloture: boolean;
  onEdit: boolean;


  currentFile?: any;
  progress = 0;
  message = '';
  previewSignsrc: string;
  public itemFile: any;
  columnIdFile: any;
  addkanban: false;
  afaire: false;
  encours: false;
  finis: false;
  LIST_IDSCOLUMNS = [];
  LIST_IDSTASKS = [];

  // selectedFiles: any;

  currentId: any = null;
  isOpen: boolean = false;
  index: number = 0;
  activeLinkIndex: number = 0;

  constructor(
    public boardService: BoardService,
    private fb: FormBuilder,
    private dragulaService: DragulaService,
    public activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private route: Router,
    private userService: UserService,
    private uploadService: UploadFilesService


  ) {
    this.activatedRoute.params.subscribe(params => {
      this.currentId = params.id;

    })
  }

  async ngOnInit(): Promise<void> {
    this.initComponent();


  }
  ngOnChanges() {
    this.initComponent()
  }

  initComponent() {

    if (this.currentId) {
      this.filterOn = false
      this.cloture = false
      this.boardService.getColumns(this.currentId).toPromise().then((res) => {
        this.boardService.getKanban(this.currentId).toPromise().then((res) => this.kanbanTitle = res.title);
        this.kanban = res;
        this.user = this.userService.user.completeName
        this.columns = res.columnList.sort(
          (a, b) => a.order - b.order
        )
      })
      this.index = 0
      this.activeLinkIndex = this.index;
    }
    this.arrow = 'file-manager-close';

  }

  addColumn(event: string) {
    const order = this.kanban.columnList.length;
    if (event) {
      this.boardService.addColumn(event, this.currentId, this.addkanban, this.afaire, this.encours, this.finis, order).toPromise().then(res => this.initComponent())
    }
    ;
  }

  onDeleteColumn(columnId: string) {

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: "auto",
      height: "auto",
      data: {
        text: `Souhaitez-vous réellement supprimer la colonne ?`
      }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.boardService.deleteColumn(this.currentId, columnId)
        .toPromise()
        .then(res => this.initComponent())
      }
    });
  }

  seeDocument(doc) {
    const dialogRef = this.dialog.open(DilogSeeDocumentComponent, {
      width: "50%",
      height: "70%",
      data: {
        document: doc.document,
      }

    });

    dialogRef.afterClosed().subscribe((res) => {
      this.initComponent();
    })
  }

  public onAddCard(event, columnId: number) {

    this.boardService.addKanbanTask(event.title, event.description, this.currentId, event.affectto, event.dueDate, event.file, columnId)
    .toPromise()
    .then(res => this.initComponent())


  }

  onAffectto($event, columnId, item) {
    // this.initComponent()
  }

  onEditTask($event, columnId, item) {

    this.boardService.EditTitleDescriptionColumn($event, this.currentId, columnId, item)
    .toPromise()
    .then(res => this.initComponent())
    if ($event.dueDate) {
      this.boardService.EditDueDate($event, this.currentId, columnId, item).subscribe(res => this.initComponent())
    }

  }


  onDeleteCard($event, columnId, itemId: string) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: "auto",
      height: "auto",
      data: {
        text: `Souhaitez-vous réellement supprimer la tache ?`
      }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.boardService.deleteCard(this.currentId, columnId, itemId)
        .toPromise()
        .then(res => this.initComponent())
      }
    });

  }

  filter(selectedOption: string) {
    switch (selectedOption) {
      case 'tache':
        this.index = 0
        this.activeLinkIndex = this.index;
        this.filterOn = true;
        this.cloture = false
        break;
      case 'tous le monde':
        this.index = 1  
        this.activeLinkIndex = this.index;
        this.filterOn = false;
        this.cloture = false
        break;
      case 'cloture':
        this.index = 2
        this.activeLinkIndex = this.index;
        this.filterOn = true;
        this.cloture = true
        break;
    }


  }


  onColorChange(color, columnId) {
    this.boardService.changeColumnColor(color, this.currentId, columnId)
    .toPromise()
    .then(res => this.initComponent())
  }

  onColumnTitle(title, columnId) {
    this.boardService.changeColumnName(title, this.currentId, columnId)
    .toPromise()
    .then(res => this.initComponent())

  }


  dropItems(event: CdkDragDrop<any>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex)
      this.item.order = event.currentIndex;
      // event.container.data.taskList.forEach(element => {
      //    this.boardService.changeorder(event.container.data.tasklist.kanbanId, event.container.data.taskList.columnId, event.container.data.taskList.taskId).subscribe(res => this.ngOnInit())
      // })
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);

      let task = this.item;
      let currentColumn = event.container.id
      let previousColumn = event.previousContainer.id

      this.boardService.changeColumnId(this.currentId, previousColumn, currentColumn, task)
      .toPromise()
      .then(res => this.initComponent())
    }
  }


  getConnectedList(): any[] {
    return this.columns.map((x) => `${x._id}`);
  }

  dropColumns(event: CdkDragDrop<string[]>) {
    this.column = event.item.data
    moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
    let index = event.item.data.order + (-(event.previousIndex - event.currentIndex))
    this.boardService.changeColumnOrder(this.currentId, this.column, index)
    .toPromise()
    .then(res => this.initComponent())
    event.container.data.forEach(res => {
      this.kanban.columnList.forEach(res2 => {
        if (res2 == res) {
          let newIndex = event.container.data.indexOf(res)
          this.boardService.changeAllColumnOrder(this.currentId, res, newIndex)
          .toPromise()
          .then(res => {});
        }
      })
    })
    this.initComponent()
  }


  onCloture(columnId, item) {
    this.boardService.cloture(this.currentId, columnId, item)
    .toPromise()
    .then(res => this.initComponent())
  }

  onOpen(columnId, item) {
    this.boardService.open(this.currentId, columnId, item)
    .toPromise()
    .then(res => this.initComponent())
  }



  sendTask($event) {
    this.item = $event
  }
  public changeDisplayOpen() {
    this.arrow = 'file-manager-open';
    this.isOpen = true;
  }
  public changeDisplay() {    
    this.arrow = 'file-manager-close';
    this.isOpen = false;

  }


  selectFile(event, columnId) {
    const nameFile = event.target.files[0].name
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.uploadService.upload(reader.result, nameFile, this.currentId, this.columnIdFile, this.itemFile)
      .toPromise()
      .then(es => this.initComponent());
    }
  }

  forItemSelectFile(itemSelectFile, columnid) {
    this.itemFile = itemSelectFile
    this.columnIdFile = columnid
  }


  onRemoveFile(columnId, item) {
    this.uploadService.removeFile(this.currentId, columnId, item)
    .toPromise()
    .then(res => this.initComponent());
  }


  seeFile(base64) {

    // base64 = base64.split('base64,')
    const imageName = 'name.png';
    const imageBlob = this.dataURItoBlob(base64);

  }

  async dataURItoBlob(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    var ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done

    var blob = (await fetch(dataURI)).blob();
    // var blob = new Blob([ab], {type: mimeString});

    this.previewSignsrc = URL.createObjectURL(await blob);
    window.open(this.previewSignsrc, "_blank")


    return blob;
  }
  updateId(value) {
    this.currentId = value;
    this.initComponent();
    this.isOpen = false;

  }

}


